import * as React from 'react';
import * as styled from './styled';
import {ClassificationGroupObject} from 'api/task/types';
import {DragDropContext, DropResult} from 'react-beautiful-dnd';
import {useContext} from '../../../../hooks/useContext';
import {Group} from './components/Group';
import {GroupVariant} from './components/Group/types';

/**
 * The classification content render.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Classification(): React.ReactElement {
  const {block} = useContext();

  // @ts-ignore
  const groups: ClassificationGroupObject[] = block.groups || [];

  /**
   * Render words.
   * @return {JSX.Element}
   */
  function renderWords(): JSX.Element {
    return (
      <styled.Words>

      </styled.Words>
    );
  }

  /**
   * Render groups.
   * @return {JSX.Element}
   */
  function renderGroups(): JSX.Element {
    /**
     * Render word box.
     * @return {JSX.Element}
     */
    function renderWordBox(): JSX.Element {
      const words = groups.map((group) => (
        group.words
      )).flat();

      return (
        <Group
          title="Выберите и перетащите"
          words={words}
          variant={GroupVariant.Empty}
        />
      );
    }

    return (
      <styled.Groups>
        {renderWordBox()}
        {groups.map((group, index) => (
          <Group
            key={index}
            title={group.title}
            words={[]}
          />
        ))}
      </styled.Groups>
    );
  }

  /**
   * The drag end event handler.
   * @param {DropResult} result
   */
  function handleDragEnd(result: DropResult): void {
    if (!result.destination) return;
  }

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <styled.Wrapper>
        {renderWords()}
        {renderGroups()}
      </styled.Wrapper>
    </DragDropContext>
  );
}
